
import React from "react";
import { useNavigate } from "react-router-dom";

export default function OrderCard({ order, role = "client" }) {
    const navigate = useNavigate();

    const shipmentStatus = order.shipment?.status ?? "Created";
    const paymentStatus =
        order.paymentStatus ?? order.shipment?.paymentStatus ?? "Pending";
    const trackingNumber = order.shipment?.trackingNumber ?? "";

    const isPaid = paymentStatus === "Paid" || paymentStatus === "Completed";

    const canEdit = (role === "employee" || role === "admin") && !isPaid;

    const detailsPath =
        role === "client"
            ? `/client/orders/${order.id}`
            : `/employee/orders/${order.id}`;

    const editPath = `/employee/orders/${order.id}/edit`;

    return (
        <div className="border rounded-lg p-4 flex justify-between items-center bg-white shadow-sm">
            <div>
                <p className="font-semibold">
                    Order #{order.orderNumber || order.id}
                </p>

                <p className="text-sm text-gray-600">
                    Status: <b>{shipmentStatus}</b>
                </p>

                <p className="text-sm text-gray-600">
                    Payment:{" "}
                    <b className={isPaid ? "text-green-600" : "text-orange-500"}>
                        {paymentStatus}
                    </b>
                </p>

                {trackingNumber && (
                    <p className="text-sm text-gray-500">
                        Tracking: {trackingNumber}
                    </p>
                )}
            </div>

            <div className="flex gap-3">
                <button
                    className="text-indigo-600 hover:underline"
                    onClick={() => navigate(detailsPath)}
                >
                    Details
                </button>

                {canEdit && (
                    <button
                        className="text-blue-600 hover:underline"
                        onClick={() => navigate(editPath)}
                    >
                        Edit
                    </button>
                )}
            </div>
        </div>
    );
}